<div class="modal-header" appCustomAutofocus>
    <h3>Voluntary Self-Identification</h3>
</div>
<div class="modal-body">
    <h4 style="font-weight: 700;">Affirmative Action Invitation to Self-Identify</h4>
    <p>
        It is the policy of {{companyName}} to provide equal opportunity to all qualified applicants for employment without regard to race, color, religion, age, sex or sexual orientation, gender identity or
        transgender status, marital or domestic partner status, ancestry, national origin, disability or AIDS/HIV status, or veteran status.  The company also has certain Affirmative Action Programs relating
        to minority, female, some veteran, and disabled applicants. If you are eligible and wish to take advantage of one or more of these Affirmative Action Programs, you are invited to identify yourself below.
        This information is confidential and will be maintained separately from your application.
    </p>

    <p>
        Completion of the remainder of this form is voluntary and any refusal to complete it will not result in any adverse treatment.
    </p>
    <div class="card border" [ngClass]="{invalidField: (formData.selectedSex == null) && validateCheck}">
        <div class="card-header bg-light">What is your EEOC <a href="https://www.eeoc.gov/youth/sex-discrimination#:~:text=Everyone%2c%20regardless%20of%20gender%2c%20is%2cwork%20at%20the%20same%20workplace" target="_blank">(Equal Employment Opportunity Commission)</a> Reporting Gender?</div>
        <div class="card card-body" style="display:flex;">
            <div class="row">
                <div class="col-lg-4 col-sm-6 col-12" style="display:flex;">
                    <input type="radio" [(ngModel)]="formData.selectedSex" name="sex" value="M" style="width:25px;height:25px;" [disabled]="true" />
                    <span style="margin-top:5px;margin-left:5px;">Male</span>
                </div>
                <div class="col-lg-4 col-sm-6 col-12" style="display:flex;">
                    <input type="radio" [(ngModel)]="formData.selectedSex" name="sex" value="F" style="width:25px;height:25px;" [disabled]="true" />
                    <span style="margin-top:5px;margin-left:5px;">Female</span>
                </div>
                <div class="col-lg-4 col-sm-12 col-12" style="display:flex;">
                    <input type="radio" [(ngModel)]="formData.selectedSex" name="sex" value="X" style="width:25px;height:25px;" [disabled]="true" />
                    <span style="margin-top:5px;margin-left:5px;">I do not wish to answer</span>
                </div>
            </div>
        </div>
    </div><br>

    <div class="card border" [ngClass]="{invalidField: (formData.GenderIdentity == null || (formData.GenderIdentity === 'O' && (formData.GenderIdentity_OtherDesc == null || formData.GenderIdentity_OtherDesc === ''))) && validateCheck}">
        <div class="card-header bg-light">What is your gender?</div>
        <div class="card card-body" style="display:flex;">
            <div class="row">
                <div class="col-lg-4 col-sm-6 col-12" style="display:flex;">
                    <input type="radio" [(ngModel)]="formData.GenderIdentity" name="gender" value="M" style="width:25px;height:25px;" [disabled]="true" />
                    <span style="margin-top:5px;margin-left:5px;">Male</span>
                </div>
                <div class="col-lg-4 col-sm-6 col-12" style="display:flex;">
                    <input type="radio" [(ngModel)]="formData.GenderIdentity" name="gender" value="F" style="width:25px;height:25px;" [disabled]="true" />
                    <span style="margin-top:5px;margin-left:5px;">Female</span>
                </div>
                <div class="col-lg-4 col-sm-12 col-12" style="display:flex;">
                    <input type="radio" [(ngModel)]="formData.GenderIdentity" name="gender" value="Z" style="width:25px;height:25px;" [disabled]="true" />
                    <span style="margin-top:5px;margin-left:5px;">I do not wish to answer</span>
                </div>
            </div>
            <div class="row" style="margin-top:10px;">
                <div class="col-lg-4 col-sm-6 col-12" style="display:flex;">
                    <input type="radio" [(ngModel)]="formData.GenderIdentity" name="gender" value="X" style="width:25px;height:25px;" [disabled]="true" />
                    <span style="margin-top:5px;margin-left:5px;">Non Binary</span>
                </div>
                <div class="col-lg-8 col-sm-12 col-12" style="display:flex;">
                    <input type="radio" [(ngModel)]="formData.GenderIdentity" name="gender" value="O" style="width:35px;height:25px;" [disabled]="true" />
                    <span style="margin-top:5px;margin-left:5px;">Other</span>
                    <input type="text" style="margin-left:10px;" class="form-control" [(ngModel)]="formData.GenderIdentity_OtherDesc" [disabled]="true" />
                </div>
            </div>
        </div>
    </div><br>


    <div class="card border" [ngClass]="{invalidField: selectedRace == null && validateCheck}">
        <div class="card-header bg-light">What is your race / ethnic origin?</div>
        <div class="card card-body">
            <div class="row">
                <div *ngFor="let data of raceList" class="col-lg-3 col-sm-6 col-12" style="margin-bottom:10px;">
                    <div style="display:flex;">
                        <input type="radio" [(ngModel)]="formData.selectedRace" name="raceSelected" [value]="data.Race" style="width:25px;height:25px;" [disabled]="true" />
                        <span style="margin-top:5px;margin-left:5px;">{{data.Description}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div><br>

    <hr style="border: 1px solid gray;" />

    <div class="card border" [ngClass]="{invalidField: formData.selectedVeteran == null && validateCheck}">
        <div class="card-header bg-light">Veteran Status (See criteria below)</div>
        <div class="card card-body" style="display:flex;">
            <div class="row">
                <label class="col-md-12 col-sm-12 col-xs-12"><strong>Are you a veteran?</strong></label>
                <div class="col-lg-4 col-sm-6 col-12" style="display:flex;">
                    <input type="radio" [(ngModel)]="formData.selectedVeteran" name="veteran" value="Y" style="width:25px;height:25px;" [disabled]="true" />
                    <span style="margin-top:5px;margin-left:5px;">Yes</span>
                </div>
                <div class="col-lg-4 col-sm-6 col-12" style="display:flex;">
                    <input type="radio" [(ngModel)]="formData.selectedVeteran" name="veteran" value="N" style="width:25px;height:25px;" [disabled]="true" />
                    <span style="margin-top:5px;margin-left:5px;">No</span>
                </div>
                <div class="col-lg-3 col-sm-12 col-12" style="display:flex;">
                    <input type="radio" [(ngModel)]="formData.selectedVeteran" name="veteran" value="X" style="width:25px;height:25px;" [disabled]="true" />
                    <span style="margin-top:5px;margin-left:5px;">I do not wish to answer</span>
                </div>
            </div>
            <div *ngIf="formData.selectedVeteran === 'Y'">
                <div class="row" style="margin-top:10px;">
                    <label class="col-lg-12 col-md-12 col-12"><strong>Are you a disabled veteran?</strong></label>
                    <div class="col-lg-4 col-md-4 col-12" style="display:flex;"><input type="radio" [(ngModel)]="formData.Veteran_Disabled" name="veteran_disable" value="true" style="width:25px;height:25px;" [disabled]="true" /><span style="margin-top:5px;margin-left:5px;">Yes</span></div>
                    <div class="col-lg-4 col-md-4 col-12" style="display:flex;"><input type="radio" [(ngModel)]="formData.Veteran_Disabled" name="veteran_disable" value="false" style="width:25px;height:25px;" [disabled]="true" /><span style="margin-top:5px;margin-left:5px;">No</span></div>
                </div>
                <div class="row" style="margin-top:10px;">
                    <label class="col-lg-12 col-md-12 col-12"><strong>Have you been awarded an Armed Forces Service Medal?</strong></label>
                    <div class="col-lg-4 col-md-4 col-12" style="display:flex;"><input type="radio" [(ngModel)]="formData.Veteran_AFServiceMedal" name="veteran_service" value="true" style="width:25px;height:25px;" [disabled]="true" /><span style="margin-top:5px;margin-left:5px;">Yes</span></div>
                    <div class="col-lg-4 col-md-4 col-12" style="display:flex;"><input type="radio" [(ngModel)]="formData.Veteran_AFServiceMedal" name="veteran_service" value="false" style="width:25px;height:25px;" [disabled]="true" /><span style="margin-top:5px;margin-left:5px;">No</span></div>
                </div>
                <div class="row" style="margin-top:10px;">
                    <label class="col-lg-12 col-md-12 col-12"><strong>Have you received an Active Duty Wartime or Campaign Badge?</strong></label>
                    <div class="col-lg-4 col-md-4 col-12" style="display:flex;"><input type="radio" [(ngModel)]="formData.Veteran_ActiveDutyWartime" name="veteran_war" value="true" style="width:25px;height:25px;" [disabled]="true" /><span style="margin-top:5px;margin-left:5px;">Yes</span></div>
                    <div class="col-lg-4 col-md-4 col-12" style="display:flex;"><input type="radio" [(ngModel)]="formData.Veteran_ActiveDutyWartime" name="veteran_war" value="false" style="width:25px;height:25px;" [disabled]="true" /><span style="margin-top:5px;margin-left:5px;">No</span></div>
                </div>
                <div class="row" style="margin-top:10px;">
                    <label class="col-lg-12 col-md-12 col-12"><strong>What was your discharge date?</strong></label>
                    <div class="input-group" style=" width: 300px; margin-left: 15px;">
                        <input type="text" class="form-control" bsDatepicker #datedp="bsDatepicker" [(ngModel)]="formData.Veteran_DischargeDate"
                               [bsConfig]="datePickerOptions" style="background-color:#ffffff" [disabled]="true">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-secondary" style="margin-right:0px" [disabled]="true">
                                <i class="oi oi-calendar"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><br>

    <h4 style="font-weight: 700;">Definitions of Veteran</h4>
    <p>
        <b>Recently Separated Veteran</b> – Any veteran during the three-year period beginning on the date of such veteran’s discharge or release from active duty in the U.S. military,
        ground, naval or air service.
    </p>
    <p>
        <b>Active Wartime or Campaign Badge Veteran</b> – A veteran who served on active duty in the U.S. military, ground, naval or air service during a war or
        in a campaign or expedition for which a campaign badge has been authorized under the laws administered by the Department of Defense.
    </p>
    <p>
        <b>Armed Forces Service Medal Veteran</b> – Any veteran who, while serving on active duty in the U.S. military, ground, naval or air service, participated
        in a United States military operation for which an Armed Forces service medal was awarded.
    </p>
    <p>
        <b>Disabled Veteran</b> – (1) A veteran of the U.S. military, ground, naval or air service who is entitled to compensation (or who but for the receipt of military retired pay would be
        entitled to compensation) under laws administered by the Secretary of Veterans Affairs, or (2) A person who was discharged or released from active duty because of a service-connected disability.
    </p>

    <hr style="border: 1px solid gray;" />

    <h4 style="font-weight: 700;">Voluntary Self-Identification of Disability</h4>
    <div *ngIf="!hideFederalMsgSelfIden" style="text-align:right;">
        <p>Form CC-305</p>
        <p>OMB Control Number 1250-0005</p>
        <p>Expires 04/30/2026</p>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-12">
            <div class="card border">
                <div class="card card-header bg-light">Why are you being asked to complete this form?</div>
                <div class="card card-body">
                    <div>
                        <p>
                            We are a federal contractor or subcontractor. The law requires us to provide equal employment opportunity to qualified
                            people with disabilities. We have a goal of having at least 7% of our workers as people with disabilities. The law says we
                            must measure our progress towards this goal. To do this, we must ask applicants and employees if they have a disability
                            or have ever had one. People can become disabled, so we need to ask this question at least every five years.
                        </p>
                        <br />
                        <p>
                            Completing this form is voluntary, and we hope that you will choose to do so. Your answer is confidential. No one who
                            makes hiring decisions will see it. Your decision to complete the form and your answer will not harm you in any way. If you
                            want to learn more about the law or this form, visit the U.S. Department of Labor’s Office of Federal Contract Compliance
                            Programs (OFCCP) website at <a href="http://www.dol.gov/ofccp">www.dol.gov/ofccp</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div><br>

    <div class="row">
        <div class="col-lg-12 col-md-12 col-12">
            <div class="card border">
                <div class="card card-header bg-light">How do you know if you have a disability?</div>
                <div class="card card-body">
                    <div>
                        <p>
                            A disability is a condition that substantially limits one or more of your “major life activities.” If you have or have ever had
                            such a condition, you are a person with a disability. <b>Disabilities include, but are not limited to:</b>
                        </p>
                        <br />
                        <div style="display:unset">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-12">
                                    <ul>
                                        <li>Alcohol or other substance use disorder (not currently using drugs illegally)</li>
                                        <li>Autoimmune disorder, for example, lupus, fibromyalgia, rheumatoid arthritis, HIV/AIDS</li>
                                        <li>Blind or low vision</li>
                                        <li>Cancer (past or present)</li>
                                        <li>Cardiovascular or heart disease</li>
                                        <li>Celiac disease</li>
                                        <li>Cerebral palsy</li>
                                        <li>Deaf or serious difficulty hearing</li>
                                        <li>Diabetes</li>
                                    </ul>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <ul>
                                        <li>Disfigurement, for example, disfigurement caused by burns, wounds, accidents, or congenital disorders</li>
                                        <li>Epilepsy or other seizure disorder</li>
                                        <li>Gastrointestinal disorders, for example, Crohn's Disease, irritable bowel syndrome</li>
                                        <li>Intellectual or developmental disability</li>
                                        <li>Mental health conditions, for example, depression, bipolar disorder, anxiety disorder, schizophrenia, PTSD</li>
                                        <li>Missing limbs or partially missing limbs</li>
                                        <li>Mobility impairment, benefiting from the use of a wheelchair, scooter, walker, leg brace(s) and/or other supports</li>
                                    </ul>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <ul>
                                        <li>Nervous system condition, for example, migraine headaches, Parkinson’s disease, multiple sclerosis (MS)</li>
                                        <li>Neurodivergence, for example, attention-deficit/hyperactivity disorder (ADHD), autism spectrum disorder, dyslexia, dyspraxia, other learning disabilities</li>
                                        <li>Partial or complete paralysis (any cause)</li>
                                        <li>Pulmonary or respiratory conditions, for example, tuberculosis, asthma, emphysema</li>
                                        <li>Short stature (dwarfism)</li>
                                        <li>Traumatic brain injury</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><br>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-12">
            <div class="card border" [ngClass]="{invalidField: formData.selectedDisability == null && validateCheck}">
                <div class="card card-header bg-light">Please check one of the boxes below:</div>
                <div class="card card-body">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-12" style="display:flex;">
                            <input type="radio" [(ngModel)]="formData.selectedDisability" name="disability" value="Y" style="width:55px;height:25px;margin-left:-5px;margin-top:5px;" [disabled]="true" />
                            <span style="margin-top:5px;margin-left:5px;">Yes, I have a disability, or have had one in the past</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-12" style="display:flex;">
                            <input type="radio" [(ngModel)]="formData.selectedDisability" name="disability" value="N" style="width:55px;height:25px;margin-left:-5px;margin-top:5px;" [disabled]="true" />
                            <span style="margin-top:5px;margin-left:5px;">No, I do not have a disability and have not had one in the past</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-12" style="display:flex;">
                            <input type="radio" [(ngModel)]="formData.selectedDisability" name="disability" value="X" style="width:25px;height:25px;margin-left:8px;margin-right:10px;" [disabled]="true" />
                            <span style="margin-top:5px;margin-left:5px;">I do not want to answer</span>
                        </div>
                    </div>
                    <div style="margin-top:10px;">
                        <p>
                            PUBLIC BURDEN STATEMENT: According to the Paperwork Reduction Act of 1995 no persons are required to respond
                            to a collection of information unless such collection displays a valid OMB control number. This survey should take about 5
                            minutes to complete.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-outline-dark" type="button" (click)="closeClick()">Close</button>
</div>